// This file is autogenerated. Any changes will be overwritten.

export const set = 'budicon';

export const name = 'roller';

export const Component = () => (
  <path d='M21.125 0H3.405C2.494 0 1.68.335 1.01 1.005.34 1.675.004 2.49.004 3.448c-.047.91.288 1.724.958 2.442.719.719 1.533 1.005 2.442.958h4.454v5.89h4.886v3.928h-.958v7.854h2.92v-7.854h-.957V11.78H8.816V6.848h12.309c.91.047 1.724-.24 2.442-.958.67-.719 1.005-1.533.958-2.442 0-1.006-.335-1.82-.958-2.443C22.897.335 22.083 0 21.125 0Zm-7.376 17.673v5.89h-1.005v-5.89h1.005ZM21.125 5.89H3.405c-.72 0-1.294-.239-1.725-.718a2.352 2.352 0 0 1-.719-1.725c0-.67.24-1.245.72-1.724.478-.479 1.053-.719 1.723-.766h17.72a2.35 2.35 0 0 1 1.725.719c.479.48.719 1.053.719 1.771 0 .67-.24 1.246-.719 1.725-.431.479-1.005.718-1.724.718Z' />
);

export const viewBox = '0 0 25 25';
